import React from 'react';
import styled from 'styled-components';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { XCircle, ArrowLeft, RefreshCw } from 'lucide-react';

const PageContainer = styled.div`
  padding-top: var(--header-h);
  min-height: 100vh;
  background: #f5f5f5;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Container = styled.div`
  max-width: 600px;
  margin: 0 auto;
  padding: 40px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  text-align: center;
`;

const ErrorIcon = styled.div`
  width: 80px;
  height: 80px;
  background: #dc3545;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 30px;
  
  svg {
    color: white;
    width: 50px;
    height: 50px;
  }
`;

const Title = styled.h1`
  font-size: 2rem;
  color: #333;
  margin-bottom: 15px;
  font-weight: 600;
`;

const Message = styled.p`
  font-size: 1.1rem;
  color: #666;
  margin-bottom: 20px;
  line-height: 1.6;
`;

const ErrorDetails = styled.div`
  background: #fee;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 30px;
  border: 1px solid #fcc;
  
  .error-text {
    color: #c33;
    font-size: 0.95rem;
    font-weight: 500;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 15px;
  justify-content: center;
  flex-wrap: wrap;
`;

const Button = styled.button`
  padding: 12px 24px;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  border: none;
  
  &.primary {
    background: #000;
    color: white;
    
    &:hover {
      background: #333;
    }
  }
  
  &.secondary {
    background: #f0f0f0;
    color: #333;
    
    &:hover {
      background: #e0e0e0;
    }
  }
`;

const PaymentFailedPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  const error = searchParams.get('error') || 'Ödeme işlemi tamamlanamadı';

  return (
    <PageContainer>
      <Container>
        <ErrorIcon>
          <XCircle />
        </ErrorIcon>
        
        <Title>Ödeme Başarısız</Title>
        <Message>
          Ödeme işleminiz tamamlanamadı. Lütfen bilgilerinizi kontrol ederek tekrar deneyin.
        </Message>

        <ErrorDetails>
          <div className="error-text">{error}</div>
        </ErrorDetails>

        <ButtonGroup>
          <Button className="primary" onClick={() => navigate('/odeme')}>
            <RefreshCw size={18} />
            Tekrar Dene
          </Button>
          <Button className="secondary" onClick={() => navigate('/sepet')}>
            <ArrowLeft size={18} />
            Sepete Dön
          </Button>
        </ButtonGroup>
      </Container>
    </PageContainer>
  );
};

export default PaymentFailedPage;
